export default "__VITE_ASSET__DkPQmrbi__"